import React, { useEffect, useState, useContext } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { graphqlRequest } from "../../api/movieApi";
import "./MovieSlider.css";
import { MdOutlineSchedule } from "react-icons/md";
import { LiaLanguageSolid } from "react-icons/lia";
import { ThemeContext } from "../../contexts/ThemeContext";

const MovieSlider = () => {
  const [movies, setMovies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { isDarkMode } = useContext(ThemeContext);

  useEffect(() => {
    document.documentElement.setAttribute(
      "data-theme",
      isDarkMode ? "dark" : "light"
    );
  }, [isDarkMode]);

  useEffect(() => {
    const fetchMovies = async () => {
      setLoading(true);
      try {
        const query = `
          query GetMovies($input: GetMoviesInput!) {
            movies(input: $input) {
              data {
                _id
                name
                originName
                posterUrl
                thumbUrl
                year
                quality
                content
                time
                lang
                slug
              }
            }
          }
        `;
        const variables2025 = {
          input: {
            page: 1,
            limit: 5,
            sortBy: "view",
            sortOrder: "desc",
            years: "2025",
          },
        };

        const variables2024 = {
          input: {
            page: 1,
            limit: 5,
            sortBy: "view",
            sortOrder: "desc",
            years: "2024",
          },
        };

        const [response2025, response2024] = await Promise.all([
          graphqlRequest(query, variables2025),
          graphqlRequest(query, variables2024),
        ]);

        const movies2025 = response2025.data.data.movies.data;
        const movies2024 = response2024.data.data.movies.data;

        setMovies([...movies2025, ...movies2024]);
        setError(null);
      } catch (err) {
        console.error("Error fetching movies:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, []);

  if (loading) {
    return 
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  return (
    <div className="movie-slider">
      <Swiper
        modules={[Navigation, Autoplay, Pagination]}
        loop={true}
        spaceBetween={10}
        slidesPerView={1}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        speed={800}
      >
        {movies.map((movie) => (
          <SwiperSlide key={movie._id}>
            <div
              className="movie-card-slider"
              style={{
                backgroundImage: `url(${isDarkMode ? movie.posterUrl : ""})`,
              }}
            >
              <div className="movie-content-slider">
                <div className="movie-thumb-slider">
                  <img src={movie.thumbUrl} alt={movie.name} />
                </div>
                <div className="movie-info-slider">
                  <p className="movie-name-slider">
                    <strong>{movie.name}</strong>
                  </p>
                  <p className="movie-origin-name-slider">{movie.originName}</p>
                  <p className="movie-info-slider-text">
                    <strong className="p-schedule">
                      <MdOutlineSchedule />
                      {movie.year} |{" "}
                    </strong>
                    <strong className="p-language">
                      <LiaLanguageSolid /> {movie.lang} |{" "}
                    </strong>
                    <strong className="p-quality">{movie.quality}</strong>
                  </p>
                  <p className="movie-content-desc-slider">{movie.content}</p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default MovieSlider;
